import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
var _excluded = ["variant", "children", "className", "enlargeOnHover", "component", "disabled", "size", "color"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Button as MuiButton } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { RaiseColors } from "componentLibrary/theme/RaiseColors";
import classNames from "classnames";
import React from "react";
import { buttonClasses } from "@mui/material/Button";

/// The Button Component has been reworked so that the default MUI variants contained | outlined | text no longer exist.
/// We have introduced our own custom variants primaryButton | secondaryButton | textButton
/// for the majority of buttons in our platform.

/// If you need a custom button that is different then the primary buttons in use DO NOT use classes
/// to change primaryButton or the other defaults inside the component its being used.

/// 1. Instead go to the button component create the button styles you need with the approved figma designs from designers.
/// 2. Pass through the styles properity name as a ButtonVariant
/// 3. go to component and the autoComplete will show the new custom button variant
import { jsx as _jsx } from "react/jsx-runtime";
var useStyles = makeStyles(function (theme) {
  return {
    primaryButton: _defineProperty(_defineProperty({
      paddingLeft: 20,
      paddingRight: 20,
      height: 36,
      borderRadius: 4,
      color: RaiseColors.white,
      fontSize: 14,
      fontWeight: 600,
      backgroundColor: RaiseColors.jllRed,
      "&:disabled": {
        boxShadow: "none",
        backgroundColor: RaiseColors.gray200,
        color: RaiseColors.white
      },
      "&:hover": {
        backgroundColor: RaiseColors.destructive500,
        boxShadow: "none",
        "@media (hover: none)": {
          boxShadow: "none"
        }
      },
      boxShadow: "none"
    }, "& .".concat(buttonClasses.focusVisible), {
      boxShadow: "none"
    }), "&:active", {
      boxShadow: "none"
    }),
    secondaryButton: {
      paddingLeft: 20,
      paddingRight: 20,
      height: 36,
      borderRadius: 4,
      color: RaiseColors.jllRed,
      background: RaiseColors.white,
      border: "1px solid ".concat(RaiseColors.jllRed),
      textTransform: "none",
      "&:hover": {
        backgroundColor: RaiseColors.grayHover
      }
    },
    textButton: {
      minWidth: 0,
      fontSize: 14,
      fontWeight: 600,
      color: RaiseColors.bahama1200,
      "&:hover": {
        backgroundColor: RaiseColors.grayHover
      }
    },
    dropDownButton: {
      paddingLeft: 12,
      paddingRight: 12,
      height: 30,
      borderRadius: 4,
      color: RaiseColors.jllRed,
      background: RaiseColors.white,
      textTransform: "none",
      "&:hover": {
        backgroundColor: RaiseColors.grayHover
      }
    },
    iconTextButton: {
      width: 99,
      height: 32,
      fontSize: 14,
      fontWeight: 600,
      color: RaiseColors.destructive500,
      display: "flex",
      "&:hover": {
        backgroundColor: RaiseColors.grayHover
      },
      "& .MuiIcon-root": {
        marginLeft: 8,
        marginTop: -4
      }
    },
    activityButton: {
      height: 32,
      borderRadius: 30,
      backgroundColor: RaiseColors.destructive100,
      padding: 8,
      "&:hover": {
        backgroundColor: RaiseColors.grayHover
      }
    },
    dealroomStatusButton: {
      backgroundColor: RaiseColors.jllRed,
      color: RaiseColors.white,
      padding: "8px 16px",
      borderRadius: 30,
      height: 32,
      textTransform: "none",
      "&:hover": {
        backgroundColor: RaiseColors.destructive500
      }
    },
    containedTextButton: {
      height: 32,
      borderRadius: 28.5,
      padding: "6px 22px",
      border: "1px solid ".concat(RaiseColors.destructive500),
      background: RaiseColors.white,
      color: RaiseColors.destructive500,
      "&:hover": {
        backgroundColor: RaiseColors.grayHover
      }
    },
    workTogetherButton: {
      color: RaiseColors.white,
      backgroundColor: RaiseColors.peach,
      borderRadius: "0px",
      fontWeight: 600,
      boxShadow: "none",
      paddingLeft: "20px",
      paddingRight: "20px",
      marginTop: "6px",
      "&:hover": {
        backgroundColor: RaiseColors.peach
      }
    },
    SignInButton: {
      backgroundColor: RaiseColors.peach,
      color: RaiseColors.white,
      width: 340,
      height: 40,
      letterSpacing: 1,
      fontWeight: 600,
      marginTop: 32,
      marginLeft: 2,
      marginBottom: 8,
      fontSize: "16px",
      borderRadius: 0,
      "&:hover": {
        height: "44px",
        width: "100.8%",
        marginTop: "30px",
        marginBottom: "6px",
        marginLeft: "0px",
        backgroundColor: RaiseColors.peach
      }
    },
    tertiaryButton: {
      width: 298,
      height: 40,
      backgroundColor: RaiseColors.jllRed,
      color: RaiseColors.white,
      fontSize: 14,
      "&:hover": {
        backgroundColor: RaiseColors.destructive500,
        boxShadow: "none",
        "@media (hover: none)": {
          boxShadow: "none"
        }
      }
    },
    workTogetherSentButton: {
      color: RaiseColors.black,
      backgroundColor: RaiseColors.white,
      borderRadius: "0px",
      fontWeight: 600,
      boxShadow: "none",
      paddingLeft: "20px",
      paddingRight: "20px",
      marginTop: "6px",
      "&:hover": {
        backgroundColor: RaiseColors.white
      }
    },
    mapButton: {
      height: 40,
      backgroundColor: RaiseColors.white,
      borderRadius: 4,
      border: "1px solid ".concat(RaiseColors.gray100),
      color: RaiseColors.gray400,
      width: 150,
      boxShadow: "0px 1px 8px rgba(0, 0, 0, 0.2)",
      "&:hover": {
        backgroundColor: RaiseColors.grayHover
      }
    },
    mapSaveButton: {
      paddingLeft: 20,
      paddingRight: 20,
      height: 36,
      borderRadius: 4,
      color: RaiseColors.gray400,
      background: RaiseColors.white,
      border: "1px solid ".concat(RaiseColors.gray400),
      textTransform: "none",
      "&:hover": {
        backgroundColor: RaiseColors.grayHover
      }
    },
    addToDealroomButton: _defineProperty(_defineProperty({
      width: 180,
      height: 36,
      borderRadius: 4,
      color: RaiseColors.white,
      fontSize: 14,
      fontWeight: 600,
      backgroundColor: RaiseColors.jllRed,
      "& :disabled": {
        backgroundColor: RaiseColors.gray200,
        color: RaiseColors.white,
        boxShadow: "none"
      },
      "&:hover": {
        backgroundColor: RaiseColors.destructive500,
        boxShadow: "none",
        "@media (hover: none)": {
          boxShadow: "none"
        }
      },
      boxShadow: "none"
    }, "& .".concat(buttonClasses.focusVisible), {
      boxShadow: "none"
    }), "&:active", {
      boxShadow: "none"
    }),
    viewDetailsButton: {
      width: 137,
      height: 36,
      borderRadius: 4,
      color: RaiseColors.jllRed,
      background: RaiseColors.white,
      border: "1px solid ".concat(RaiseColors.jllRed),
      textTransform: "none",
      "&:disabled": {
        border: "1px solid ".concat(RaiseColors.gray200),
        color: RaiseColors.gray200
      },
      "&:hover": {
        backgroundColor: RaiseColors.grayHover
      }
    },
    mapCancelButton: {
      minWidth: 0,
      fontSize: 14,
      height: 36,
      fontWeight: 600,
      color: RaiseColors.white
    },
    iconToggle: {
      borderColor: RaiseColors.gray200,
      background: "white",
      border: "1px solid"
    },
    iconTogglePill: {
      border: "1px solid ".concat(RaiseColors.gray300),
      background: "white",
      borderBottomLeftRadius: 20,
      borderTopLeftRadius: 20
    },
    transition: {
      transition: "all 50ms cubic-bezier(.5,0,0,1)",
      "&:hover": {
        transform: "scale(1.05)"
      }
    },
    filterToggleButton: {
      height: 32,
      padding: "4px 8px 4px 8px",
      color: RaiseColors.gray300,
      border: "1px solid ".concat(RaiseColors.gray300),
      "&:hover": {
        color: RaiseColors.black,
        borderColor: RaiseColors.black,
        backgroundColor: RaiseColors.white
      }
    },
    filterTogglePill: {
      height: 32,
      padding: "4px 8px 4px 8px",
      color: RaiseColors.gray300,
      border: "1px solid ".concat(RaiseColors.gray300),
      backgroundColor: RaiseColors.white,
      borderBottomRightRadius: 20,
      borderTopRightRadius: 20,
      "&:hover": {
        color: RaiseColors.black,
        borderColor: RaiseColors.black,
        backgroundColor: RaiseColors.white
      }
    },
    addDetailsButton: {
      paddingLeft: 20,
      paddingRight: 20,
      height: 36,
      borderRadius: 4,
      color: RaiseColors.jllRed,
      background: RaiseColors.white,
      position: "absolute",
      top: "10px",
      left: "10px"
    },
    // New Design System Styles
    newPrimary: {
      textTransform: "none",
      padding: "10px 24px",
      backgroundColor: RaiseColors.midnight,
      boxShadow: "0px 0px 16px rgba(73, 0, 227, 0.08)",
      borderRadius: 200,
      color: RaiseColors.neutral100,
      "&:hover": {
        backgroundColor: RaiseColors.bahama1200
      },
      "&:active": {
        backgroundColor: RaiseColors.neutral500
      },
      "&:disabled": {
        backgroundColor: RaiseColors.neutral200,
        color: RaiseColors.neutral500,
        border: "1px solid ".concat(RaiseColors.neutral300)
      }
    },
    newSecondary: {
      textTransform: "none",
      padding: "8px 16px",
      backgroundColor: RaiseColors.neutral100,
      border: "1px solid ".concat(RaiseColors.neutral300),
      boxShadow: "0px 0px 8px 0px ".concat(RaiseColors.midnight, "14"),
      borderRadius: 200,
      color: RaiseColors.midnight,
      "&:hover": {
        backgroundColor: RaiseColors.neutral100,
        border: "1px solid ".concat(RaiseColors.bahama1200)
      },
      "&:active": {
        color: RaiseColors.bahama1200
      }
    },
    newSecondaryTeal: {
      textTransform: "none",
      padding: "8px 16px",
      backgroundColor: RaiseColors.neutral100,
      border: "1px solid ".concat(RaiseColors.neutral300),
      boxShadow: "0px 0px 8px 0px ".concat(RaiseColors.teal, "14"),
      borderRadius: 200,
      color: RaiseColors.midnight,
      "&:hover": {
        backgroundColor: RaiseColors.neutral100,
        border: "1px solid ".concat(RaiseColors.teal)
      }
    },
    newSecondaryBroker: {
      background: RaiseColors.white,
      border: "1px solid ".concat(RaiseColors.grayscale200),
      color: RaiseColors.glacier2400,
      borderRadius: 200,
      "&:hover": {
        backgroundColor: RaiseColors.neutral100,
        border: "1px solid ".concat(RaiseColors.teal),
        color: RaiseColors.glacier2400
      },
      "&:active": {
        boxShadow: "0px 0px 4px 2px ".concat(RaiseColors.bahama1200),
        color: RaiseColors.bahama1200,
        border: "1px solid ".concat(RaiseColors.grayscale200),
        backgroundColor: RaiseColors.white
      }
    },
    newSecondaryClient: {
      textTransform: "none",
      padding: "8px 16px",
      backgroundColor: RaiseColors.jllNeutral100,
      border: "1px solid ".concat(RaiseColors.jllNeutral300),
      boxShadow: "0px 0px 8px 0px ".concat(RaiseColors.blue500, "14"),
      borderRadius: 200,
      color: RaiseColors.midnight,
      "&:hover": {
        backgroundColor: RaiseColors.jllNeutral100,
        border: "1px solid ".concat(RaiseColors.blue500)
      }
    },
    newTertiary: {
      color: RaiseColors.teal,
      textTransform: "none"
    },
    icon: {
      borderRadius: "200px",
      padding: "8px 16px",
      backgroundColor: RaiseColors.neutral100,
      boxShadow: "0px 0px 8px 0px ".concat(RaiseColors.midnight, "14"),
      minWidth: "40px",
      width: "40px",
      height: "40px",
      "&:hover": {
        border: "1px solid ".concat(RaiseColors.jllRed)
      }
    }
  };
});
var Button = function Button(_ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? "textButton" : _ref$variant,
    children = _ref.children,
    className = _ref.className,
    enlargeOnHover = _ref.enlargeOnHover,
    component = _ref.component,
    disabled = _ref.disabled,
    size = _ref.size,
    color = _ref.color,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useStyles();
  if (variant && variant in classes) {
    className = classNames(className, classes[variant]);
  }
  return /*#__PURE__*/_jsx(MuiButton, _objectSpread(_objectSpread({
    className: classNames(className, _defineProperty({}, classes.transition, enlargeOnHover)),
    variant: variant && variant in classes ? undefined : variant,
    disabled: disabled,
    component: component,
    size: size
  }, props), {}, {
    children: children
  }));
};
export default Button;